import { useEffect } from "react";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

export default function Fancybox({ children }) {
  useEffect(() => {
    let Fancybox;

    import("@fancyapps/ui").then((mod) => {
      Fancybox = mod.Fancybox;

      Fancybox.unbind("[data-fancybox]");

      Fancybox.bind("[data-fancybox]", {
        infinite: true,

        Autoplay: {
          timeout: 3000,
          showProgress: true,
        },

        Toolbar: {
          display: [
            "counter",
            "zoom",
            "slideshow",
            "fullscreen",
            "close",
          ],
        },

        Thumbs: false,
      });
    });

    return () => {
      Fancybox?.destroy();
    };
  }, []);

  return <>{children}</>;
}



